function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import filter from 'lodash/filter';
import map from 'lodash/map';
import { formatTimestamp } from 'helpers/datetime';
import Avatar from 'components/Avatar';
import noteShape from 'shapes/noteShape';
import ReplyBtn from './ReplyBtn';
import ReplyNoteForm from './ReplyNoteForm';
import styles from './VisitNotes.pcss';
var _React_PureComponent;
class ReplyNote extends (_React_PureComponent = React.PureComponent) {
    get Avatars() {
        const { pwdAvatar, hcpAvatar, mode } = this.props;
        const PwdAvatar = pwdAvatar && /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: pwdAvatar.avatar,
            name: [
                pwdAvatar.firstName,
                pwdAvatar.lastName
            ],
            className: styles.avatar,
            imgClassName: styles.avatar__img,
            initialsClassName: styles.avatar__initials
        });
        const HcpAvatar = hcpAvatar && /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: hcpAvatar.avatar,
            name: [
                hcpAvatar.firstName,
                hcpAvatar.lastName
            ],
            className: `${styles.avatar} mr-3`,
            imgClassName: styles.avatar__img,
            initialsClassName: styles.avatar__initials
        });
        const isPWDMode = mode === 'PWD';
        return {
            MyAvatar: isPWDMode ? PwdAvatar : HcpAvatar,
            ResponderAvatar: isPWDMode ? HcpAvatar : PwdAvatar
        };
    }
    renderReplyNoteForm(note) {
        if (note !== this.props.replyingTo) {
            return null;
        }
        return /*#__PURE__*/ _jsx(ReplyNoteForm, {
            note: note,
            withActionButtons: this.props.isReplyNoteFormWithActionButtons,
            onDidMount: (noteFormRef)=>this.props.onReplyNoteFormDidMount(noteFormRef),
            onCancel: this.props.onCancel,
            onChange: this.props.onChange,
            onSubmit: this.props.onSubmit
        });
    }
    renderReplyFooter(note, canReply) {
        if (!canReply) return null;
        return /*#__PURE__*/ _jsx("div", {
            className: "mt-5 d-flex text--base justify-content-end",
            children: /*#__PURE__*/ _jsx(ReplyBtn, {
                note: note,
                onReply: this.props.onReply
            })
        });
    }
    renderReplies(replies) {
        const repliesLast = replies.length - 1;
        return map(replies, (replyNote, idx)=>{
            const replyNoteProps = _object_spread_props(_object_spread({}, this.props), {
                note: replyNote,
                isLast: idx === repliesLast
            });
            return /*#__PURE__*/ _jsx(ReplyNote, _object_spread_props(_object_spread({}, replyNoteProps), {
                onReplyNoteFormDidMount: (noteFormRef)=>this.props.onReplyNoteFormDidMount(noteFormRef)
            }), replyNote.noteId);
        });
    }
    render() {
        const { mode, note, replyNotes, replyingTo, isLast } = this.props;
        if (!note) {
            return null;
        }
        const replies = filter(replyNotes, (rn)=>rn.payload && rn.payload.replyTo === note.noteId);
        const canReply = isLast && !replies.length && note !== replyingTo;
        // const isSentByModeUser = note.payload
        //   && (
        //     (mode === 'PWD' && note.payload.byPwd)
        //     || (mode === 'HCP' && !note.payload.byPwd)
        //   );
        let isSentByModeUser = false;
        if (note.payload) {
            isSentByModeUser = mode === 'PWD' && note.payload.byPwd || mode === 'HCP' && !note.payload.byPwd;
        } else if (mode === 'HCP' && note.noteType !== 'Note') {
            isSentByModeUser = true;
        }
        const { timestamp } = note;
        const date = formatTimestamp(timestamp, 'L, LT');
        const { MyAvatar, ResponderAvatar } = this.Avatars;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: cn('w-100', {
                        'mb-5': !canReply
                    }, {
                        'd-flex flex-column align-items-end justify-content-end text--right': isSentByModeUser
                    }),
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: cn('w-100 w-md-75 d-flex flex-nowrap align-items-end', {
                                'justify-content-end': isSentByModeUser
                            }),
                            children: [
                                !isSentByModeUser && /*#__PURE__*/ _jsx("div", {
                                    className: "mr-3",
                                    children: ResponderAvatar
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: cn('pseudoEditorWrapper', styles.replyNoteWrapper, {
                                        [styles['replyNoteWrapper--primary']]: isSentByModeUser
                                    }),
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: `pseudoEditor ${styles.note}`,
                                            children: note.content
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: styles.note__date,
                                            children: date
                                        })
                                    ]
                                }),
                                isSentByModeUser && /*#__PURE__*/ _jsx("div", {
                                    className: "ml-3",
                                    children: MyAvatar
                                })
                            ]
                        }),
                        this.renderReplyFooter(note, canReply, isSentByModeUser)
                    ]
                }),
                this.renderReplyNoteForm(note),
                this.renderReplies(replies)
            ]
        });
    }
}
_define_property(ReplyNote, "propTypes", {
    // Explicit props
    mode: PropTypes.oneOf([
        'HCP',
        'PWD'
    ]).isRequired,
    note: noteShape,
    replyNotes: PropTypes.arrayOf(noteShape).isRequired,
    replyingTo: noteShape,
    pwdAvatar: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        avatar: PropTypes.string
    }),
    hcpAvatar: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        avatar: PropTypes.string
    }),
    isLast: PropTypes.bool,
    isReplyNoteFormWithActionButtons: PropTypes.bool,
    // Explicit actions
    onReplyNoteFormDidMount: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onReply: PropTypes.func,
    onSubmit: PropTypes.func
});
export default ReplyNote;
